import { createContext, type ReactNode, useContext } from 'react';
import type { AppClient } from './client';

/**
 * The one injection point for the data layer. Screens call `useAppClient()` and
 * get an `AppClient`; whether that is the FixtureClient or the HTTP client is
 * decided once, in main.tsx. Swapping it is the entire integration step.
 */
const ClientContext = createContext<AppClient | null>(null);

export function ClientProvider({
  client,
  children,
}: {
  readonly client: AppClient;
  readonly children: ReactNode;
}) {
  return <ClientContext.Provider value={client}>{children}</ClientContext.Provider>;
}

export function useAppClient(): AppClient {
  const client = useContext(ClientContext);
  if (client === null) {
    throw new Error('useAppClient must be used inside <ClientProvider>');
  }
  return client;
}
